import React, { useEffect } from "react";
import hideMenu from "../../../utilities/hideMenu";
import Footer from "../../Shared/Footer/Footer";
import Navigation from "../../Shared/Navigation/Navigation";
import Form from "../Form/Form";

const Contact = () => {
    useEffect(() => {
        hideMenu();
    }, []);

    return (
        <>
            <Navigation />
            <div className="main">
                <Form />
            </div>
            <Footer />
        </>
    );
};

export default Contact;
